import useLeadsScript from './useLeadsScript'
import useAddressRelatedScript from './useAddressRelatedScript'
import useTelecomContractRelatedScript from './useTelecomContractRelatedScript'

const useScripts = () => {
  const { leadScripts } = useLeadsScript()
  const { addressRelatedScripts, leadProxiserve } = useAddressRelatedScript()
  const { telecomScripts } = useTelecomContractRelatedScript()
  const scripts = {
    ...leadScripts,
    ...addressRelatedScripts,
    ...telecomScripts,
    ...(leadProxiserve ? { leadProxiserve } : {}),
  }

  return {
    scripts,
  }
}

export default useScripts
